import Table2Wage from "./Table2Wage";


export default Table2Wage